/* LOUNGE CREW: provador "Experimente a sua"
   (templates/collection.provador.liquid + assets/lc-provador.css).

   Passo 1 escolhe a peça (products.json por coleção + /search?view=provador, que é
   templates/search.provador.liquid em JSON), passo 2 pede contato e a foto, passo 3 mostra a prova,
   o tamanho e leva para a página da camiseta com a numeração já escolhida.
   Quem lê o corpo e veste a pessoa é o servidor do checkout (api/provador.js): daqui saem a foto,
   o handle da peça e o contato. A foto não é guardada em lugar nenhum. */
(function () {
  var raiz = document.querySelector('[data-prv]');
  if (!raiz) return;

  var API = raiz.getAttribute('data-api');
  var $ = function (s, r) { return (r || raiz).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || raiz).querySelectorAll(s)); };
  var OH = window.OH || { routes: {} };

  var HEX = {
    'Branco': '#F7F6F2', 'Preto': '#151515', 'Cinza Estonado': '#5B5A58', 'Areia': '#D8C3A1',
    'Cinza Mescla': '#B9B8B6', 'Off-White': '#EDE6D6', 'Marinho': '#1F2A44', 'Chocolate': '#4B3126',
    'Azul Bebê': '#BFD7EE', 'Bordô': '#6A1F2B', 'Verde Musgo': '#6E7556'
  };
  var TAMANHOS = ['P', 'M', 'G', 'GG', 'XGG'];
  var POR_PAGINA = 18;
  var CHAVE_LEAD = 'lc_provador_lead';

  var esc = function (v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var dinheiro = function (centavos) {
    var v = (Number(centavos || 0) / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  };
  var comLargura = function (url, w) {
    if (!url) return '';
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  };
  var frase = function (titulo) {
    var m = String(titulo || '').match(/[“"]([^”"]+)[”"]/);
    return m ? m[1] : String(titulo || '');
  };
  var guardar = function (chave, valor) { try { localStorage.setItem(chave, valor); } catch (e) { /* janela anônima */ } };
  var lembrar = function (chave) { try { return localStorage.getItem(chave); } catch (e) { return null; } };

  var E = {
    peca: null, cor: null, caimento: 'oversized', tamanho: null,
    foto: null, k: null, leitura: null, medidas: null, vista: 'costas',
    provas: {}, fila: {}, falhou: {}, lead: null, registrado: false
  };
  try { E.lead = JSON.parse(lembrar(CHAVE_LEAD) || 'null'); } catch (e) { E.lead = null; }

  /* ------------------------- passos ------------------------- */
  function passo(n) {
    $$('.prv__step').forEach(function (s) { s.hidden = Number(s.getAttribute('data-passo')) !== n; });
    $$('[data-passo-item]').forEach(function (li) {
      var i = Number(li.getAttribute('data-passo-item'));
      li.classList.toggle('is-on', i === n);
      li.classList.toggle('is-done', i < n);
    });
    raiz.classList.toggle('is-compacto', n !== 1);
    if (n !== 2) pararCamera();
    var topo = raiz.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > topo) window.scrollTo({ top: topo, behavior: 'smooth' });
  }

  /* -------------------- passo 1: escolher a peça -------------------- */
  var grade = $('[data-grid]'), vazio = $('[data-vazio]'), maisBtn = $('[data-mais]');
  var busca = $('[data-busca]'), limpar = $('[data-limpar]');
  var lista = 'camisetas', pagina = 1, termo = '';

  function cartao(p) {
    var img = p.imagem ? '<img src="' + esc(comLargura(p.imagem, 500)) + '" alt="' + esc(p.titulo) + '" loading="lazy" decoding="async" width="400" height="500">' : '';
    return '<button type="button" class="prvcard" data-peca="' + esc(p.handle) + '">' +
      '<span class="prvcard__img">' + img + '<span class="prvcard__marca">Provar</span></span>' +
      '<span class="prvcard__nome serif">“' + esc(frase(p.titulo)) + '”</span>' +
      '<span class="prvcard__preco">' + esc(p.preco) + '</span></button>';
  }

  // A vitrine e o card usam o preço da 1ª variante (a oversized), não o mínimo do produto.
  function daLoja(p) {
    var v1 = (p.variants || [])[0];
    var img = (p.images || [])[0];
    return { handle: p.handle, titulo: p.title, imagem: img ? String(img.src) : '', preco: v1 ? dinheiro(Math.round(Number(v1.price) * 100)) : '' };
  }

  function mostrar(pecas, juntar) {
    if (!juntar) grade.innerHTML = '';
    grade.insertAdjacentHTML('beforeend', pecas.map(cartao).join(''));
    vazio.hidden = grade.children.length > 0;
  }

  function ocupado(sim) {
    maisBtn.disabled = sim;
    maisBtn.textContent = sim ? 'Carregando…' : 'Carregar mais';
  }

  function carregar(juntar) {
    ocupado(true);
    var url = termo
      ? '/search?q=' + encodeURIComponent(termo) + '&type=product&view=provador&page=' + pagina
      : '/collections/' + encodeURIComponent(lista) + '/products.json?limit=' + POR_PAGINA + '&page=' + pagina;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) throw new Error('lista');
        if (termo) {
          mostrar(j.itens || [], juntar);
          maisBtn.parentNode.hidden = !j.mais;
        } else {
          var todos = j.products || [];
          mostrar(todos.filter(function (p) { return p.product_type === 'Camisetas'; }).map(daLoja), juntar);
          maisBtn.parentNode.hidden = todos.length < POR_PAGINA;
        }
      })
      .catch(function () { maisBtn.parentNode.hidden = true; })
      .then(function () { ocupado(false); });
  }

  maisBtn.addEventListener('click', function () { pagina += 1; carregar(true); });

  var menu = $('[data-menu]'), menuBtn = $('[data-menu-btn]'), menuPainel = $('[data-menu-painel]');
  function abrirMenu(sim) {
    menu.toggleAttribute('data-aberto', sim);
    menuBtn.setAttribute('aria-expanded', sim ? 'true' : 'false');
    menuPainel.hidden = !sim;
  }
  menuBtn.addEventListener('click', function () { abrirMenu(menuPainel.hidden); });
  document.addEventListener('click', function (e) { if (!menu.contains(e.target)) abrirMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menuPainel.hidden) { abrirMenu(false); menuBtn.focus(); } });

  $$('[data-lista]').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('[data-lista]').forEach(function (o) { o.classList.toggle('is-on', o === b); o.setAttribute('aria-selected', o === b ? 'true' : 'false'); });
      $('[data-menu-val]').textContent = b.textContent.trim();
      abrirMenu(false);
      lista = b.getAttribute('data-lista');
      pagina = 1; termo = '';
      busca.value = ''; limpar.hidden = true;
      maisBtn.parentNode.hidden = false;
      carregar(false);
    });
  });

  var relogio = null;
  busca.addEventListener('input', function () {
    var q = busca.value.trim();
    limpar.hidden = !q;
    clearTimeout(relogio);
    relogio = setTimeout(function () {
      if (q.length && q.length < 2) return;
      termo = q;
      pagina = 1;
      maisBtn.parentNode.hidden = false;
      carregar(false);
    }, 280);
  });
  limpar.addEventListener('click', function () { busca.value = ''; limpar.hidden = true; termo = ''; pagina = 1; carregar(false); busca.focus(); });

  grade.addEventListener('click', function (e) {
    var b = e.target.closest('[data-peca]');
    if (b) escolherPeca(b.getAttribute('data-peca'));
  });

  /* -------------------- a peça escolhida -------------------- */
  // alt: "Camiseta “X”, Cor, caimento oversized|regular" ou "Camiseta “X”, Cor, frente"; nas Estampas,
  // só "Camiseta “X”, Cor" (essas existem apenas em oversized). O formato antigo, separado por
  // travessão, continua sendo lido. Cor e tipo saem do FIM, porque o título pode ter vírgula.
  function lerAlt(alt) {
    var partes = String(alt || '').replace(/\s*\u2014\s*/g, ', ').split(', ').map(function (s) { return s.trim(); });
    if (partes.length < 2) return null;
    var ult = partes[partes.length - 1].replace(/^caimento\s+/i, '').toLowerCase();
    if (ult === 'regular' || ult === 'oversized' || ult === 'frente') {
      return { tipo: ult, cor: partes.length > 2 ? partes[partes.length - 2] : '' };
    }
    var cor = partes[partes.length - 1];
    if (cor.indexOf('”') >= 0) return null;
    return { tipo: 'oversized', cor: cor };
  }

  function escolherPeca(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('peça'); return r.json(); })
      .then(function (p) {
        if (p.type !== 'Camisetas') throw new Error('tipo');
        var fotos = {}, frenteFoto = null;
        (p.media || []).forEach(function (m) {
          var lido = lerAlt(m.alt);
          if (!lido) return;
          if (lido.tipo === 'frente') { frenteFoto = frenteFoto || m.src; return; }
          if (!lido.cor || (lido.tipo !== 'oversized' && lido.tipo !== 'regular')) return;
          fotos[lido.cor] = fotos[lido.cor] || {};
          if (!fotos[lido.cor][lido.tipo]) fotos[lido.cor][lido.tipo] = m.src;
        });
        var nomes = Object.keys(fotos);
        if (!nomes.length) throw new Error('sem fotos');
        var eixo = {};
        (p.options || []).forEach(function (o, i) { eixo[o.name] = i; });

        E.peca = {
          handle: p.handle, titulo: p.title, fotos: fotos, frente: frenteFoto,
          variantes: p.variants || [], eixo: eixo,
          caimentos: eixo.Caimento === undefined ? ['oversized'] : ['oversized', 'regular']
        };
        E.caimento = E.peca.caimentos[0];
        E.cor = nomes.indexOf('Preto') >= 0 ? 'Preto' : nomes[0];
        E.provas = {}; E.fila = {};
        pintarCaimentos();
        pintarPeca();
        pintarCores($('[data-cores]'));
        passo(2);
      })
      .catch(function () { aviso(erro2, 'Não consegui abrir essa camiseta. Escolha outra.'); passo(1); });
  }

  function fotoDaPeca(cor, caimento) {
    var c = (E.peca.fotos[cor] || {});
    return c[caimento] || c.oversized || c.regular || '';
  }

  function pintarPeca() {
    $('[data-peca-img]').src = comLargura(fotoDaPeca(E.cor, E.caimento), 200);
    $('[data-peca-nome]').textContent = '“' + frase(E.peca.titulo) + '”';
    $('[data-peca-sub]').textContent = 'Camiseta · ' + E.cor;
  }

  function pintarCores(caixa) {
    if (!caixa) return;
    caixa.innerHTML = Object.keys(E.peca.fotos).map(function (c) {
      return '<button type="button" class="corbtn' + (c === E.cor ? ' is-on' : '') + '" role="radio" aria-checked="' +
        (c === E.cor ? 'true' : 'false') + '" style="background:' + (HEX[c] || '#CCC') + '" data-cor="' + esc(c) + '" title="' + esc(c) + '">' +
        '<span class="visually-hidden">' + esc(c) + '</span></button>';
    }).join('');
  }

  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cor]');
    if (!b) return;
    E.cor = b.getAttribute('data-cor');
    pintarCores($('[data-cores]'));
    pintarCores($('[data-cores-res]'));
    pintarPeca();
    if (!$('.prv__step[data-passo="3"]').hidden) { pintarCompra(); pintarProva(); }
  });

  $('[data-trocar-peca]').addEventListener('click', function () { passo(1); });

  // O caimento é escolhido ANTES da foto: é ele que decide a foto da peça usada na prova
  // e a linha da tabela de medidas que vale para o tamanho.
  function pintarCaimentos() {
    var so = E.peca && E.peca.caimentos.length < 2;
    $$('[data-c]').forEach(function (b) {
      var c = b.getAttribute('data-c');
      var tem = !E.peca || E.peca.caimentos.indexOf(c) >= 0;
      b.hidden = !tem;
      b.classList.toggle('is-on', c === E.caimento);
      b.setAttribute('aria-checked', c === E.caimento ? 'true' : 'false');
    });
    $('[data-caimento-unico]').hidden = !so;
    $('[data-caimentos]').style.gridTemplateColumns = so ? '1fr' : '';
  }
  $$('[data-c]').forEach(function (b) {
    b.addEventListener('click', function () {
      E.caimento = b.getAttribute('data-c');
      pintarCaimentos();
      pintarPeca();
    });
  });

  /* -------------------- contato antes da foto -------------------- */
  var lead = $('[data-lead]'), leadForm = $('[data-lead-form]'), leadErro = $('[data-lead-erro]');
  var leadEmail = $('[data-lead-email]'), leadTel = $('[data-lead-tel]'), leadNome = $('[data-lead-nome]');
  var depoisDoLead = null;
  fetch(API, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      if (j && j.email) $('[data-lead-sub]').textContent = 'O resultado aparece aqui na tela, na hora, e também vai para o seu e-mail. O contato fica com a gente para guardar o seu tamanho e avisar de novidades e promoções.';
    })
    .catch(function () {});

  var soDigitos = function (v) { return String(v || '').replace(/\D/g, ''); };
  function mascara(v) {
    var d = soDigitos(v).slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : '';
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }
  leadTel.addEventListener('input', function () { leadTel.value = mascara(leadTel.value); });

  var temLead = function () { return Boolean(E.lead && E.lead.email); };

  function pedirLead(depois) {
    depoisDoLead = depois || null;
    aviso(leadErro, '');
    lead.hidden = false;
    travar();
    setTimeout(function () { (leadNome.value ? leadEmail : leadNome).focus(); }, 60);
  }
  function fecharLead() {
    lead.hidden = true;
    travar();
    depoisDoLead = null;
  }
  $$('[data-lead-fechar]').forEach(function (b) { b.addEventListener('click', fecharLead); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lead.hidden && doc.hidden) fecharLead(); });

  leadForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = leadEmail.value.trim();
    var tel = soDigitos(leadTel.value);
    leadEmail.classList.toggle('is-erro', !/^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(email));
    leadTel.classList.toggle('is-erro', !(tel.length === 10 || tel.length === 11));
    if (leadEmail.classList.contains('is-erro')) return aviso(leadErro, 'Confira o e-mail: precisa ser um endereço válido.');
    if (leadTel.classList.contains('is-erro')) return aviso(leadErro, 'Confira o WhatsApp: DDD + número, 10 ou 11 dígitos.');

    var botao = $('[data-lead-ok]');
    botao.disabled = true;
    botao.textContent = 'Salvando…';
    E.lead = { nome: leadNome.value.trim(), email: email, telefone: tel, aceite: $('[data-lead-aceite]').checked };
    guardar(CHAVE_LEAD, JSON.stringify(E.lead));

    pedir({ acao: 'lead', lead: E.lead, peca: E.peca ? E.peca.handle : '' })
      .catch(function () { /* o cadastro é nosso problema, não do cliente: o funil segue */ })
      .then(function () {
        botao.disabled = false;
        botao.textContent = 'Continuar para a foto';
        var segue = depoisDoLead;
        fecharLead();
        if (segue) segue();
      });
  });

  /* -------------------- pop-ups: guia de medidas e páginas da loja -------------------- */
  var medidas = $('[data-medidas]'), doc = $('[data-doc]');
  var guardados = {};

  // a rolagem só é liberada quando nenhum pop-up está aberto
  function travar() {
    var aberto = !lead.hidden || !medidas.hidden || !doc.hidden;
    document.documentElement.classList.toggle('lock', aberto);
  }

  function abrirMedidas(sim) {
    if (sim) {
      var caixa = $('[data-medidas-corpo]');
      if (!caixa.innerHTML) caixa.innerHTML = ($('[data-medidas-html]') || {}).innerHTML || '';
    }
    medidas.hidden = !sim;
    travar();
  }

  /** Abre uma página da loja aqui dentro: busca o HTML e traz só o corpo do documento. */
  function abrirDoc(url) {
    doc.hidden = false;
    travar();
    var titulo = $('[data-doc-titulo]'), corpo = $('[data-doc-corpo]');
    if (guardados[url]) {
      titulo.textContent = guardados[url].titulo;
      corpo.innerHTML = guardados[url].corpo;
      return;
    }
    titulo.textContent = '';
    corpo.innerHTML = '<p class="muted">Carregando…</p>';
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var h = d.querySelector('.docpage__title');
        var c = d.querySelector('.docpage__body .rte');
        if (!c || !c.innerHTML.trim()) throw new Error('vazio');
        guardados[url] = { titulo: h ? h.textContent.trim() : '', corpo: c.innerHTML };
        titulo.textContent = guardados[url].titulo;
        corpo.innerHTML = guardados[url].corpo;
      })
      .catch(function () {
        corpo.innerHTML = '<p>Não consegui abrir aqui. <a class="u" href="' + url + '" target="_blank" rel="noopener">Abrir a página</a>.</p>';
      });
  }
  function fecharDoc() { doc.hidden = true; travar(); }

  raiz.addEventListener('click', function (e) {
    // os links continuam apontando para a página: sem JS eles funcionam, com JS abrem aqui mesmo
    if (e.target.closest('[data-abrir-medidas]')) { e.preventDefault(); abrirMedidas(true); return; }
    if (e.target.closest('[data-medidas-fechar]')) { abrirMedidas(false); return; }
    var link = e.target.closest('[data-abrir-doc]');
    if (link) { e.preventDefault(); abrirDoc(link.getAttribute('href')); return; }
    if (e.target.closest('[data-doc-fechar]')) fecharDoc();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!doc.hidden) fecharDoc();
    else if (!medidas.hidden) abrirMedidas(false);
  });

  /* -------------------- passo 2: a foto -------------------- */
  var video = $('[data-video]'), preview = $('[data-preview]'), guia = $('[data-guia]');
  var camVazio = $('[data-cam-vazio]'), contagem = $('[data-contagem]');
  var btnCamera = $('[data-abrir-camera]'), btnDisparar = $('[data-disparar]'), btnRefazer = $('[data-refazer]');
  var rotuloEnviar = $('[data-enviar-rotulo]'), arquivo = $('[data-arquivo]');
  var btnProvar = $('[data-provar]'), erro2 = $('[data-erro2]');
  var fluxo = null;

  function aviso(onde, txt) {
    if (!onde) return;
    onde.textContent = txt || '';
    onde.hidden = !txt;
  }

  function pararCamera() {
    if (fluxo) { fluxo.getTracks().forEach(function (t) { t.stop(); }); fluxo = null; }
    video.hidden = true;
    guia.hidden = true;
    btnDisparar.hidden = true;
    contagem.hidden = true;
  }

  function abrirCamera() {
    aviso(erro2, '');
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      aviso(erro2, 'Seu navegador não abre a câmera aqui. Use "Enviar uma foto".');
      return;
    }
    btnCamera.disabled = true;
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 1706 } }, audio: false })
      .then(function (s) {
        fluxo = s;
        video.srcObject = s;
        video.hidden = false;
        preview.hidden = true;
        camVazio.hidden = true;
        guia.hidden = false;
        btnDisparar.hidden = false;
        btnRefazer.hidden = true;
        return video.play();
      })
      .catch(function () { aviso(erro2, 'Não consegui abrir a câmera. Autorize o acesso ou use "Enviar uma foto".'); })
      .then(function () { btnCamera.disabled = false; });
  }

  btnCamera.addEventListener('click', function () {
    if (!temLead()) return pedirLead(abrirCamera);
    abrirCamera();
  });
  // O rótulo abre o seletor de arquivo sozinho: sem contato, seguramos e abrimos depois.
  rotuloEnviar.addEventListener('click', function (e) {
    if (temLead()) return;
    e.preventDefault();
    pedirLead(function () { arquivo.click(); });
  });

  btnDisparar.addEventListener('click', function () {
    if (!fluxo) return;
    btnDisparar.disabled = true;
    var n = 3;
    contagem.hidden = false;
    contagem.textContent = n;
    var t = setInterval(function () {
      n -= 1;
      if (n > 0) { contagem.textContent = n; return; }
      clearInterval(t);
      contagem.hidden = true;
      btnDisparar.disabled = false;
      capturar();
    }, 800);
  });

  function paraTela(largura, altura) {
    var lado = Math.max(largura, altura);
    var f = lado > 1100 ? 1100 / lado : 1;
    return { w: Math.round(largura * f), h: Math.round(altura * f) };
  }

  function capturar() {
    var d = paraTela(video.videoWidth, video.videoHeight);
    var c = document.createElement('canvas');
    c.width = d.w; c.height = d.h;
    c.getContext('2d').drawImage(video, 0, 0, d.w, d.h);
    usarFoto(c.toDataURL('image/jpeg', 0.86));
    pararCamera();
  }

  function usarFoto(dataUri) {
    E.foto = dataUri;
    E.k = null;
    // o selo não custa nada e não depende da leitura: pedir agora tira um ida-e-volta do caminho crítico
    pedir({ acao: 'iniciar', foto: dataUri }).then(function (j) {
      if (j && j.ok && j.k && E.foto === dataUri) E.k = j.k;
    }).catch(function () {});
    preview.src = dataUri;
    preview.hidden = false;
    camVazio.hidden = true;
    guia.hidden = true;
    btnRefazer.hidden = false;
    btnCamera.hidden = true;
    rotuloEnviar.hidden = true;
    btnProvar.disabled = false;
    aviso(erro2, '');
  }

  btnRefazer.addEventListener('click', function () {
    E.foto = null; E.k = null;
    preview.hidden = true; preview.removeAttribute('src');
    camVazio.hidden = false;
    btnRefazer.hidden = true;
    btnCamera.hidden = false;
    rotuloEnviar.hidden = false;
    btnProvar.disabled = true;
    aviso(erro2, '');
  });

  arquivo.addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!f) return;
    if (f.size > 25 * 1024 * 1024) { aviso(erro2, 'Essa imagem é pesada demais. Tente outra.'); return; }
    aviso(erro2, '');
    reduzir(f).then(usarFoto).catch(function () { aviso(erro2, 'Não consegui ler essa imagem. Tente outra.'); });
  });

  // Reduz para caber no corpo da requisição e, de quebra, resolve a orientação do EXIF do celular.
  function reduzir(arq) {
    var desenhar = function (fonte, largura, altura) {
      var d = paraTela(largura, altura);
      var c = document.createElement('canvas');
      c.width = d.w; c.height = d.h;
      c.getContext('2d').drawImage(fonte, 0, 0, d.w, d.h);
      return c.toDataURL('image/jpeg', 0.86);
    };
    if (window.createImageBitmap) {
      return createImageBitmap(arq, { imageOrientation: 'from-image' })
        .then(function (bm) { var s = desenhar(bm, bm.width, bm.height); if (bm.close) bm.close(); return s; })
        .catch(function () { return porImagem(arq, desenhar); });
    }
    return porImagem(arq, desenhar);
  }
  function porImagem(arq, desenhar) {
    return new Promise(function (ok, falhou) {
      var url = URL.createObjectURL(arq);
      var im = new Image();
      im.onload = function () { try { ok(desenhar(im, im.naturalWidth, im.naturalHeight)); } catch (e) { falhou(e); } URL.revokeObjectURL(url); };
      im.onerror = function () { URL.revokeObjectURL(url); falhou(new Error('imagem')); };
      im.src = url;
    });
  }

  /* -------------------- o servidor -------------------- */
  function pedir(corpo) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, mensagem: 'Resposta inesperada do provador.' }; });
    });
  }

  btnProvar.addEventListener('click', function () {
    if (!E.foto || !E.peca) return;
    if (!temLead()) return pedirLead(function () { btnProvar.click(); });
    btnProvar.disabled = true;
    btnProvar.textContent = 'Lendo o seu corpo…';
    aviso(erro2, '');

    pedir({ acao: 'analisar', foto: E.foto, caimento: E.caimento })
      .then(function (j) {
        btnProvar.disabled = false;
        btnProvar.textContent = 'Ver em mim';
        if (!j.ok) {
          aviso(erro2, (j.mensagem || 'Não consegui ler essa foto. Tente outra.') + (j.dica ? ' ' + j.dica : ''));
          return;
        }
        E.k = j.k || E.k;
        E.leitura = j.leitura;
        E.medidas = j.medidas;
        E.caimento = E.peca.caimentos.indexOf(j.medidas.caimento) >= 0 ? j.medidas.caimento : E.peca.caimentos[0];
        E.tamanho = j.medidas[E.caimento].tamanho;
        E.vista = 'costas';
        E.provas = {}; E.fila = {};
        passo(3);
        pintarResultado();
        E.registrado = false;
        provar('costas');
        // se a imagem não vier, o tamanho entra no cadastro assim mesmo
        setTimeout(function () { registrarResultado(''); }, 45000);
      })
      .catch(function () {
        aviso(erro2, 'Não consegui falar com o provador. Tente de novo em instantes.');
        btnProvar.disabled = false;
        btnProvar.textContent = 'Ver em mim';
      });
  });

  function chave(vista) { return E.cor + '|' + E.caimento + '|' + vista; }

  var REFAZER = { ia_indisponivel: 1, demorou: 1 };

  function falhar(ch, msg) {
    delete E.fila[ch];
    E.falhou[ch] = msg;
    pintarProva();
  }

  /**
   * Uma prova, com uma segunda chance automática. A requisição carrega a foto e demora ~20 s: no
   * celular ela morre de vez em quando (tela apagada, troca de antena). Em vez de mostrar um erro,
   * tenta de novo sozinha uma vez; só depois disso aparece o botão dentro do quadro.
   */
  function provar(vista, tentativa) {
    tentativa = tentativa || 0;
    var ch = chave(vista);
    if (E.provas[ch] || E.fila[ch]) { pintarProva(); return; }
    E.fila[ch] = true;
    delete E.falhou[ch];
    aviso($('[data-erro3]'), '');
    pintarProva();

    pedir({ acao: 'provar', foto: E.foto, k: E.k, peca: E.peca.handle, cor: E.cor, caimento: E.caimento, vista: vista })
      .then(function (j) {
        if (j && j.ok && j.imagem) {
          delete E.fila[ch];
          E.provas[ch] = j.imagem;
          pintarProva();
          registrarResultado(j.imagem);
          return;
        }
        // o selo vale 20 min: se venceu, tira outro e tenta mais uma vez
        if (j && j.erro === 'selo_invalido' && tentativa === 0) {
          return pedir({ acao: 'iniciar', foto: E.foto }).then(function (r) {
            delete E.fila[ch];
            if (r && r.ok && r.k) { E.k = r.k; provar(vista, 1); }
            else falhar(ch, j.mensagem);
          }).catch(function () { falhar(ch, j.mensagem); });
        }
        if (j && REFAZER[j.erro] && tentativa === 0) { delete E.fila[ch]; provar(vista, 1); return; }
        falhar(ch, (j && j.mensagem) || 'Não consegui gerar a prova agora.');
      })
      .catch(function () {
        delete E.fila[ch];
        if (tentativa === 0) { provar(vista, 1); return; }
        falhar(ch, 'A prova não chegou até aqui. Toque em “Tentar de novo”.');
      });
  }

  /** O tamanho vai para o cadastro (e para o e-mail, quando o envio estiver ligado) uma vez só. */
  function registrarResultado(imagem) {
    if (E.registrado || !E.lead || !E.tamanho) return;
    E.registrado = true;
    var v = variante(E.cor, E.caimento, E.tamanho);
    pedir({
      acao: 'lead', lead: E.lead, peca: E.peca.handle,
      tamanho: E.tamanho, caimento: E.caimento,
      titulo: E.peca.titulo, preco: v ? dinheiro(v.price) : '',
      variante: v ? v.id : null, imagem: imagem || ''
    }).catch(function () {});
  }

  /* -------------------- passo 3: a prova e o tamanho -------------------- */
  var provaImg = $('[data-prova-img]'), provaLoad = $('[data-prova-load]'), provaTxt = $('[data-prova-txt]');
  var baixar = $('[data-baixar]');

  function pintarProva() {
    var ch = chave(E.vista);
    var url = E.provas[ch];
    var carregando = Boolean(E.fila[ch]);
    provaImg.hidden = !url;
    provaLoad.hidden = Boolean(url);
    baixar.hidden = !url;
    if (url) {
      provaImg.src = url;
      provaImg.alt = 'Você vestindo a camiseta “' + frase(E.peca.titulo) + '” ' + E.cor.toLowerCase() + ', caimento ' + E.caimento;
      baixar.href = url;
      return;
    }
    $('[data-prova-spin]').hidden = !carregando;
    $('[data-prova-retry]').hidden = carregando;
    if (carregando) {
      provaTxt.innerHTML = E.vista === 'costas'
        ? 'Vestindo você…<br><small>A estampa fica nas costas. Leva uns 20 segundos.</small>'
        : 'Virando para a frente…<br><small>Leva uns 20 segundos.</small>';
      return;
    }
    $('[data-prova-retry]').textContent = E.falhou[ch] ? 'Tentar de novo' : 'Ver a prova nesta opção';
    provaTxt.textContent = E.falhou[ch] || 'Esta cor e este caimento ainda não foram gerados.';
  }

  $('[data-prova-retry]').addEventListener('click', function () { provar(E.vista); });

  $$('[data-vista]').forEach(function (b) {
    b.addEventListener('click', function () {
      E.vista = b.getAttribute('data-vista');
      $$('[data-vista]').forEach(function (o) { o.classList.toggle('is-on', o === b); o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      if (!E.provas[chave(E.vista)] && !E.fila[chave(E.vista)]) provar(E.vista);
      else pintarProva();
    });
  });

  function pintarResultado() {
    var m = E.medidas, l = E.leitura;
    $('[data-res-tam]').textContent = m[E.caimento].tamanho;
    $('[data-res-caimento]').textContent = E.caimento === 'oversized' ? 'Oversized' : 'Regular';

    var opcoes = $('[data-res-opcoes]');
    opcoes.classList.toggle('res__opcoes--um', E.peca.caimentos.length < 2);
    opcoes.innerHTML = E.peca.caimentos.map(function (c) {
      return '<button type="button" class="fitbtn' + (c === E.caimento ? ' is-on' : '') + '" role="radio" aria-checked="' + (c === E.caimento ? 'true' : 'false') + '" data-fit="' + c + '">' +
        '<b>' + (c === 'oversized' ? 'Oversized' : 'Regular') + '</b>' +
        '<i>' + m[c].tamanho + '</i>' +
        '<small>' + m[c].largura + ' cm de largura · ' + m[c].comprimento + ' cm de altura</small></button>';
    }).join('');

    var avisos = (m.avisos || []).slice();
    if (l.confianca === 'baixa') avisos.push('A foto deixou pouca informação à vista: confira a tabela de medidas antes de fechar.');
    var ul = $('[data-res-avisos]');
    ul.innerHTML = avisos.map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('');
    ul.hidden = !avisos.length;

    $('[data-tabela]').innerHTML = ($('[data-medidas-html]') || {}).innerHTML || '';
    pintarCores($('[data-cores-res]'));
    pintarCompra();
  }

  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fit]');
    if (!b) return;
    E.caimento = b.getAttribute('data-fit');
    E.tamanho = E.medidas[E.caimento].tamanho;
    pintarResultado();
    pintarProva();
  });

  function variante(cor, caimento, tamanho) {
    var ix = E.peca.eixo;
    return E.peca.variantes.filter(function (v) {
      if (v.options[ix['Cor']] !== cor || v.options[ix['Tamanho']] !== tamanho) return false;
      if (ix['Caimento'] === undefined) return true;
      return v.options[ix['Caimento']] === (caimento === 'oversized' ? 'Oversized' : 'Regular');
    })[0] || null;
  }

  function pintarCompra() {
    $('[data-res-peca]').textContent = '“' + frase(E.peca.titulo) + '”';
    $('[data-tams]').innerHTML = TAMANHOS.map(function (t) {
      var v = variante(E.cor, E.caimento, t);
      return '<button type="button" class="sizebtn-p' + (t === E.tamanho ? ' is-on' : '') + '"' + (v && v.available ? '' : ' disabled') +
        ' role="radio" aria-checked="' + (t === E.tamanho ? 'true' : 'false') + '" data-tam="' + t + '">' + t + '</button>';
    }).join('');
    var v = variante(E.cor, E.caimento, E.tamanho);
    $('[data-res-preco]').textContent = v ? dinheiro(v.price) : '';
    var comprar = $('[data-comprar]'), add = $('[data-add]');
    var pode = Boolean(v && v.available);
    comprar.disabled = !pode;
    add.disabled = !pode;
    if (pode) add.setAttribute('data-quick-add', v.id); else add.removeAttribute('data-quick-add');
    comprar.textContent = pode ? 'Comprar no tamanho ' + E.tamanho + ' ' + (E.caimento === 'oversized' ? 'oversized' : 'regular') : 'Esgotado nessa combinação';
    pintarPeca();
  }

  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tam]');
    if (!b || b.disabled) return;
    E.tamanho = b.getAttribute('data-tam');
    pintarCompra();
  });

  // Comprar leva à página da camiseta com cor, caimento e tamanho já escolhidos (?variant=).
  $('[data-comprar]').addEventListener('click', function () {
    var v = variante(E.cor, E.caimento, E.tamanho);
    if (!v || !v.available) return;
    location.href = '/products/' + E.peca.handle + '?variant=' + v.id;
  });
  // "Adicionar à sacola" tem data-quick-add: quem adiciona e abre a gaveta é o theme.js.

  $('[data-outra-peca]').addEventListener('click', function () { passo(1); });
  $('[data-outra-foto]').addEventListener('click', function () { btnRefazer.click(); passo(2); });

  /* -------------------- chegada com ?produto= -------------------- */
  var params = new URLSearchParams(location.search);
  var vindo = params.get('produto');
  if (vindo && /^[a-z0-9-]{3,120}$/.test(vindo)) {
    escolherPeca(vindo).then(function () {
      var cor = params.get('cor');
      if (cor && E.peca && E.peca.fotos[cor]) {
        E.cor = cor;
        pintarCores($('[data-cores]'));
        pintarPeca();
      }
    });
  }
})();
